import React from 'react';
import { Modal as BootstrapModal, Button } from 'react-bootstrap';
import './Modal.css';

function Modal({ isOpen, onClose, title, message }) {
  return (
    <BootstrapModal
      show={isOpen}
      onHide={onClose}
      centered
      className="custom-modal"
    >
      <BootstrapModal.Header closeButton>
        <BootstrapModal.Title>{title}</BootstrapModal.Title>
      </BootstrapModal.Header>
      <BootstrapModal.Body>{message}</BootstrapModal.Body>
      <BootstrapModal.Footer>
        <Button variant="primary" onClick={onClose}>
          Close
        </Button>
      </BootstrapModal.Footer>
    </BootstrapModal>
  );
}

export default Modal; 